import React from "react";
const THRules = () => {
  return (
    <>
      <>
  <div id="main-area">
  <div id="article">
  <h1 id="Rules">
    {" "}
    <a href="https://discord.com/channels/1175757068779663410/1175764882088534136" aria-labelledby="Rules" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    กฎ
  </h1>
  <p>
  หน้านี้อธิบายหลักการรัฐธรรมนูญและกฎ&การลงโทษของเซิร์ฟเวอร์ EnbyBase
  <br /><b>**เนื่องจากนี่คือ 'การแปล' ภาษาไทย จึงมีผลเฉพาะในเวอร์ชันภาษาอังกฤษเท่านั้น**</b>
  <br />หากต้องการดูเวอร์ชันภาษาอังกฤษ โปรดคลิกไอคอนด้านบน
  </p>
  <h2 id="Constitutional Principles">
    {" "}
    <a href="https://discord.com/channels/1175757068779663410/1175764882088534136" aria-labelledby="Constitutional Principles" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    หลักการรัฐธรรมนูญ (หลักการพื้นฐาน)
  </h2>

  <h3 id="cpsection1" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 1.
  </h3>
  <p>
  This server is a safe place to Non-binary people, transgender people, and the entire LGBTQIAN+
people. 
  </p>
  <h3 id="cpsection2" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 2.
  </h3>
  <p>
  All powers have a hierarchy in EnbyBase alliance:
  <br />Constitutional Principles-Rules&Sanctions-owner’s order-moderator’s order by management rank
  </p>
  <h3 id="cpsection3" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 3.
  </h3>
  <p>
  Legislative branch in EnbyBase alliance belong to the parliament. Parliament shall be composed of
members included in the moderator team. Constitutional Principles, Rules & Sanctions modifications
and important issues are carried out according to the entire procedure of ‘CP-Rulemaking’ on
#open-parliament of EnbyBase Discord server, the official website and other platforms. 
  </p>
  <h4 id="CP-Rulemaking" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
  CP-Rulemaking
  </h4>
First, a member of parliament sponsors a bill, after discussion, the bill is put on a calendar to be
voted on. If more than 1/2 of registered parliament members voted and ‘Agree’ is more than 1/2 of
voted members, the bill is passed and promulgated by the owner.
<br />Second, more than two members of parliament sponsors a bill of Constitutional Principles
modification, after discussion, the bill is put on a calendar to be voted on. If more than 1/2 of
registered parliament members voted and 'Agree' is more than 2/3 of voted members, the bill is sent
to public vote, all members can participate. If 'Agree' of public vote result is more than 1/2, the bill is
passed and promulgated by the owner. 
<br />Veto, a bill returning action, can be issued by the owner when bill is passed that is contrary to basic
human rights and the Yogyakarta principles. If the bill is returned by the veto, It can be passed by
post-veto vote without the owner's agreement in this case: satisfying more than 1/2 of registered
parliament members voted and 'Agree' is more than 2/3 of voted members
  <h3 id="cpsection4" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 4.
  </h3>
  <p>
  Judiciary branch in EnbyBase alliance belong to the moderator team of each platform.
Punishment can be imposed by a member of Staff Team
Punishment logs aren’t synchronised between platforms unless the owner’s order is issued.
Supreme court (after appealing) are carried out according to the entire procedure of ‘CPSuperiortrial’ on #open-supreme-court of EnbyBase Discord server, the official website and other
platforms.
<br />Discipline and dismissal of Staff Team follow the same procedures as punishment of general
members. But only #mod-discussion and #open-supreme-court can determine status of discipline
and dismissal.
  </p>
  <h4 id="CP-Superiortrial" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
  CP-Superiortrial (Final Appeal)
  </h4>
  Anyone who believes they have been unfairly punished can appeal and superior trial will be held on
#open-supreme-court of EnbyBase Discord server, the official website and other platforms. The
defendant can use counsel. Other moderator team members except person who imposed the
previous punishment can judge. Some random members and partner server representatives can be
summoned as jurors. The status will be confirmed as the result of Supreme Court. 
  <h3 id="cpsection5" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 5.
  </h3>
  <p>
  The official website, YouTube, and external site accounts are modified, added, and deleted
according to the owner's permission.
  </p>
  <h3 id="cpsection6" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 6.
  </h3>
  <p>
  For the roles class of the moderator, management rank is separated into Administrator (O) and  (E).
  <br />Department may vary depending on what #staff-discussion determines.
  </p>
  <h3 id="cpsection7" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 7.
  </h3>
  <p>
  Channels are modified, added, and deleted according to the owner and admin's permission. 
  </p>
  <h3 id="cpsection8" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 8.
  </h3>
  <p>
  Staff Team has authorities as each platform’s permission setting said. 
  </p>
  
  <h2 id="Rules & Sanctions">
    {" "}
    <a href="https://discord.com/channels/1175757068779663410/1175764882088534136" aria-labelledby="Rules & Sanctions" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    กฎ&การลงโทษ
  </h2>
  <p>การลงโทษสามารถกำหนดได้โดย Moderator และจำเลยสามารถประท้วงได้โดยเปิด Ticket ที่ #contact-mods
      <br />หากคุณอุทธรณ์ การพิจารณาคดีสาธารณะจะจัดขึ้นใน #open-supreme-court
      <br />มีระบบเตือน 4 ระดับ หน่วยนับคือข้อความ
(ตัดสินขึ้นอยู่กับบริบท)<br /> ในกรณีคำเตือนครั้งแรกและครั้งที่สอง ปัญหาอาจถูกส่งต่อไปยังคำเตือนด้วยวาจา ขึ้นอยู่กับการตัดสินใจของ Moderator <br />ตั้งแต่ครั้งที่ 3 เป็นต้นไป การลงโทษมาตรา 10 ที่รุนแรงขึ้นจะตามมา
  </p>
  <h3 id="Section 1 to 10: General">
    {" "}
    <a href="https://discord.com/channels/1175757068779663410/1175764882088534136" aria-labelledby="Rules & Sanctions" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    มาตรา 1 ถึง 10: ธรรมดา
  </h3>
  <h3 id="rssection1" style={{fontFamily: 'FoundryContextW03Md, LINESeedSansTH_Bd, sans-serif'}}>
  มาตรา 1.
  </h3>
  <p>
  มีน้ำใจและให้เกียรติซึ่งกันและกัน
  <br />ผู้ใดไม่ให้เกียรติซึ่งกันและกัน ต้องระวางโทษ timeout ตั้งแต่ 1 นาที ถึง 1 วัน
  </p>
  <h3 id="rssection2" style={{fontFamily: 'FoundryContextW03Md, LINESeedSansTH_Bd, sans-serif'}}>
  มาตรา 2.
  </h3>
  <p>
  รักษาโปรไฟล์ดิสคอร์ดของคุณให้เหมาะสม
  <br />ผู้ใดมีโปรไฟล์ที่ไม่เหมาะสม ต้องระวางโทษ timeout ตั้งแต่ 1 นาที ถึง 1 วัน
  </p>
  <h3 id="rssection3" style={{fontFamily: 'FoundryContextW03Md, LINESeedSansTH_Bd, sans-serif'}}>
  มาตรา 3.
  </h3>
  <p>
  อย่าสแปม
  <br />ผู้ใดส่งสแปม ต้องระวางโทษ timeout ตั้งแต่ 1 นาที ถึง 1 วัน
  </p>
  <h3 id="rssection4" style={{fontFamily: 'FoundryContextW03Md, LINESeedSansTH_Bd, sans-serif'}}>
  มาตรา 4.
  </h3>
  <p>
  ไม่มี self-promotion (การโปรโมตตนเอง) หรือโฆษณาบนเซิร์ฟเวอร์นี้ ยกเว้นช่อง #self-promotion
  <br />ผู้ใดส่ง self-promotion (การโปรโมตตนเอง) หรือโฆษณาบนเซิร์ฟเวอร์นี้ ยกเว้นช่อง #self-promotion ต้องระวางโทษ timeout ตั้งแต่ 1 นาที ถึง 1 วัน
  </p>
  <h3 id="rssection5" style={{fontFamily: 'FoundryContextW03Md, LINESeedSansTH_Bd, sans-serif'}}>
  มาตรา 5.
  </h3>
  <p>
  อย่าข้อความ transphobic, queerphobic และ enbyphobic สิ่งเหล่านี้เป็นสิ่งต้องห้ามโดยเด็ดขาด
  <br />ผู้ใดส่งข้อความมีเนื้อหา transphobic, queerphobic และ enbyphobic ต้องระวางโทษ timeout ตั้งแต่ 1 วัน ถึง 1 สัปดาห์
  </p>
  <h3 id="rssection6" style={{fontFamily: 'FoundryContextW03Md, LINESeedSansTH_Bd, sans-serif'}}>
  มาตรา 6.
  </h3>
  <p>
  อย่าพูดแสดงความเกลียดชังหรือภาษาที่เป็นอันตราย
  <br />ผู้ใดพูดแสดงความเกลียดชังหรือภาษาที่เป็นอันตราย ต้องระวางโทษ timeout ตั้งแต่ 1 นาที ถึง 1 วัน
  </p>
  <h3 id="rssection7" style={{fontFamily: 'FoundryContextW03Md, LINESeedSansTH_Bd, sans-serif'}}>
  มาตรา 7.
  </h3>
  <p>
  อย่าส่งเนื้อหาที่น่าสงสัย
  <br />ผู้ใดอัพโหลดหรือแชทเนื้อหาที่น่าสงสัย ต้องระวางโทษ timeout ตั้งแต่ 1 นาที ถึง 1 วัน
  </p>
  <h3 id="rssection8" style={{fontFamily: 'FoundryContextW03Md, LINESeedSansTH_Bd, sans-serif'}}>
  มาตรา 8.
  </h3>
  <p>
  กฎเกณฑ์อยู่ภายใต้สามัญสำนึก
  <br />ผู้ใดมีพฤติกรรมที่ไม่ธรรมดา ต้องระวางโทษ timeout ตั้งแต่ 1 นาที ถึง 1 วัน
  </p>
  <h3 id="rssection9" style={{fontFamily: 'FoundryContextW03Md, LINESeedSansTH_Bd, sans-serif'}}>
  มาตรา 9.
  </h3>
  <p>
  Extremist Ideologies are not allowed on this server and partnership servers.
<br />Whoever their profile or their messages on channel of EnbyBase alliance contain the extremist
ideology, they will be notified by DM (Direct Message) and shall be punished with account timeout
(suspension) of 1 day.
<br />Any partnership is terminated if this partnership server spreads extremist ideology or is present on
the server. 
<br />Definition of 'Extremist Ideologies': Anti-Capitalism, Communism, Totalitarianism, Fascism,
Nazism, Racism and Anti-Globalism{/*
  <p>
  ไม่อนุญาตให้ใช้อุดมการณ์หัวรุนแรงบนเซิร์ฟเวอร์นี้และเซิร์ฟเวอร์ Partnership
  <br />ผู้ใดมีอุดมการณ์หัวรุนแรงบนโปรไฟล์ของพวกเขา พวกเขาจะได้รับแจ้งทาง DM (ข้อความโดยตรง) และ ต้องระวางโทษ timeout 1 วัน
  <br />'Partnership' ใด จะถูกยกเลิกหากเซิร์ฟเวอร์ Partnership นี้เผยแพร่อุดมการณ์หัวรุนแรงหรือปรากฏอยู่บนเซิร์ฟเวอร์
  <br />คำจำกัดความของ 'อุดมการณ์หัวรุนแรง': ต่อต้านทุนนิยม ลัทธิคอมมิวนิสต์ เผด็จการนิยม ลัทธิฟาสซิสต์ ลัทธิเหยียดเชื้อชาติ ต่อต้านโลกาภิวัตน์ และ ชาตินิยมและปฏิกิริยานิยม</p>
  <h3 id="rspc" style={{fontFamily: 'FoundryContextW03Md, LINESeedSansTH_Bd, sans-serif'}}>
  มาตรา 10. การลงโทษที่รุนแรง
  </h3>
  <p>
  คำเตือนครั้งที่ 3 เป็นการหมดเวลาเพิ่มเติมอีก 1 วัน นอกเหนือจากคำเตือนที่มีอยู่ <br />คำเตือนครั้งที่ 4 ถือเป็นการแบนถาวร
*/}</p>
<h3 id="Section 11 to 12: Server and Owner">
    {" "}
    <a href="https://discord.com/channels/1175757068779663410/1175764882088534136" aria-labelledby="Rules & Sanctions" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    มาตรา 11 ถึง 12: เซิร์ฟเวอร์และเจ้าของ
  </h3>
  <h3 id="rssection11" style={{fontFamily: 'FoundryContextW03Md, LINESeedSansTH_Bd, sans-serif'}}>
  มาตรา 11.
  </h3>
  <p>
  ผู้ใดตามที่พยายามแฮ็คเซิร์ฟเวอร์ ต้องระวางโทษ แบนถาวร รายงานต่อดิสคอร์ด และ ดำเนินการทางกฎหมาย
  </p>
  <h3 id="rssection12" style={{fontFamily: 'FoundryContextW03Md, LINESeedSansTH_Bd, sans-serif'}}>
  มาตรา 12.
  </h3>
  <p>
  ผู้ใดหมิ่นประมาท ใช้คำสบถกับเจ้าของ ต้องระวางโทษ timeout ตั้งแต่ 1 วัน ถึง 1 สัปดาห์ และ/หรือ บัญชีถูกเตะ หรือ แบนถาวร
  </p>
</div>
</div>
</>

    </>
  );
}

export default THRules;